import { supabase } from "@/integrations/supabase/client";
import { LibraryBookmark } from "@/types/library";

export const libraryBookmarksService = {
  // הוספת שמור
  async addBookmark(itemType: string, itemId: string): Promise<LibraryBookmark> {
    const {
      data: { user },
    } = await supabase.auth.getUser();
    if (!user) throw new Error("User not authenticated");

    const { data, error } = await supabase
      .from("library_bookmarks")
      .insert({
        user_id: user.id,
        item_id: itemId,
        item_type: itemType,
      })
      .select()
      .single();

    if (error) throw error;
    return data as LibraryBookmark;
  },

  // הסרת שמור
  async removeBookmark(itemType: string, itemId: string): Promise<void> {
    const {
      data: { user },
    } = await supabase.auth.getUser();
    if (!user) throw new Error("User not authenticated");

    const { error } = await supabase
      .from("library_bookmarks")
      .delete()
      .eq("user_id", user.id)
      .eq("item_id", itemId)
      .eq("item_type", itemType);

    if (error) throw error;
  },

  // קבלת כל השמורים של משתמש
  async getBookmarks(itemType?: string, userId?: string): Promise<LibraryBookmark[]> {
    let targetUserId = userId;
    if (!targetUserId) {
      const {
        data: { user },
      } = await supabase.auth.getUser();
      targetUserId = user?.id;
    }
    if (!targetUserId) return [];

    let query = supabase
      .from("library_bookmarks")
      .select("*")
      .eq("user_id", targetUserId)
      .order("created_at", { ascending: false });

    if (itemType) {
      query = query.eq("item_type", itemType);
    }

    const { data, error } = await query;

    if (error) throw error;
    return (data || []) as LibraryBookmark[];
  },

  // בדיקה אם פריט שמור
  async isBookmarked(itemType: string, itemId: string): Promise<boolean> {
    const {
      data: { user },
    } = await supabase.auth.getUser();
    if (!user) return false;

    const { data, error } = await supabase
      .from("library_bookmarks")
      .select("id")
      .eq("user_id", user.id)
      .eq("item_id", itemId)
      .eq("item_type", itemType)
      .maybeSingle();

    if (error) throw error;
    return !!data;
  },

  // הסרת שמור לפי ID
  async removeBookmarkById(bookmarkId: string): Promise<void> {
    const { error } = await supabase
      .from("library_bookmarks")
      .delete()
      .eq("id", bookmarkId);

    if (error) throw error;
  },
};
